import BankAccountService from './bank';
import CardService from './card';

class PaymentsService {
  bankAccount =  new BankAccountService();
  card = new CardService();
}

export default PaymentsService;
